import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var State;
(function (State) {
    State["ACTIVE"] = "ACTIVE";
    State["INACTIVE"] = "INACTIVE";
    State["DELETED"] = "DELETED";
})(State || (State = {}));
export var PrimaryType;
(function (PrimaryType) {
    PrimaryType["NETWORK"] = "NETWORK";
    PrimaryType["BUYER"] = "BUYER";
    PrimaryType["SELLER"] = "SELLER";
    PrimaryType["DATA_PROVIDER"] = "DATA_PROVIDER";
})(PrimaryType || (PrimaryType = {}));
export var SegmentTypeEnum;
(function (SegmentTypeEnum) {
    SegmentTypeEnum["MY_SEGMENT"] = "MY_SEGMENT";
    SegmentTypeEnum["SHARED_SEGMENT"] = "SHARED_SEGMENT";
    SegmentTypeEnum["MICROSOFT"] = "MICROSOFT";
    SegmentTypeEnum["DATA_MARKETPLACE"] = "DATA_MARKETPLACE";
    SegmentTypeEnum["NOT_DEFINED"] = "NOT_DEFINED";
})(SegmentTypeEnum || (SegmentTypeEnum = {}));
export var SupportedMacroTypes;
(function (SupportedMacroTypes) {
    SupportedMacroTypes["true_false"] = "true_false";
    SupportedMacroTypes["string"] = "string";
    SupportedMacroTypes["url"] = "url";
    SupportedMacroTypes["integer"] = "integer";
    SupportedMacroTypes["decimal"] = "decimal";
    SupportedMacroTypes["file"] = "file";
    SupportedMacroTypes["select_from_list"] = "select_from_list";
})(SupportedMacroTypes || (SupportedMacroTypes = {}));
export var DeviceTypeTarget;
(function (DeviceTypeTarget) {
    DeviceTypeTarget["PHONE"] = "PHONE";
    DeviceTypeTarget["TABLET"] = "TABLET";
    DeviceTypeTarget["PC"] = "PC";
    DeviceTypeTarget["TV"] = "TV";
    DeviceTypeTarget["GAMECONSOLE"] = "GAMECONSOLE";
    DeviceTypeTarget["STB"] = "STB";
})(DeviceTypeTarget || (DeviceTypeTarget = {}));
export var FloorApplicationTarget;
(function (FloorApplicationTarget) {
    FloorApplicationTarget["EXTERNAL_ONLY"] = "EXTERNAL_ONLY";
    FloorApplicationTarget["EXTERNAL_NON_PREFERRED"] = "EXTERNAL_NON_PREFERRED";
    FloorApplicationTarget["ALL"] = "ALL";
})(FloorApplicationTarget || (FloorApplicationTarget = {}));
